import { Stack, Box } from '@chakra-ui/react'
import { Book } from './ListItem'
import { ScrollableContent } from '@!/Store/Home/components'
import { SectionTitle } from './'

/* 各画面に表示される横スクロール型の特集リスト */
export const ScrollableFeatureList = ({ title, pathname, books, tabName }) => {
  return (
    <Stack spacing={0} mx={4}>
      <SectionTitle title={title} url={`/store/features/${pathname}`} tabName={tabName} />
      <ScrollableContent>
        <Stack direction="row" spacing={0}>
          {books.map((book, index) => (
            <Box key={`list-${index}-${book.content_id}`} mr={3}>
              <Book
                title={book.name}
                contentId={book.content_id}
                imageUrl={book.image_url}
                sectionTitle={tabName ? `${tabName}_${title}` : undefined}
                w="100px"
              />
            </Box>
          ))}
        </Stack>
      </ScrollableContent>
    </Stack>
  )
}
